import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const CommonSwitch = ({ checked, onChange, disabled, defaultValue, value, name, id }) => {
  return (
    <StylesSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      name={name}
      id={id}
      inputProps={{ role: 'checkbox' }}
    />
  );
};

export default CommonSwitch;

const StylesSwitch = styled(Switch)(() => ({
  width: '44px',
  height: '25px',
  padding: '0',
  display: 'flex',

  '& .MuiSwitch-switchBase': {
    color: 'var(--text-default)',
    height: '25px',
    padding: 6,

    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: 'var(--color-primary)',

      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'var(--switch-bg)',
      },
    },

    '&:hover, & .MuiSwitch-switchBase:hover': {
      backgroundColor: 'transparent',
    },

    '&.Mui-disabled, &.Mui-checked.Mui-disabled': {
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'transparent',
        border: '1px solid var(--input-border-disabled)',
      },
    },
    '&.Mui-disabled': {
      color: 'var(--input-placeholder)',
    },
    '&.Mui-checked.Mui-disabled': {
      color: 'var(--color-primary-70)',
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    borderRadius: 100,
    transition: 'width 0.2s',
  },

  '& .MuiSwitch-track': {
    borderRadius: 100,
    opacity: 1,
    backgroundColor: 'transparent',
    border: '1px solid var(--input-border)',
    boxSizing: 'border-box',
  },
}));
